import React from 'react';
import Layouts from '../Components/Layouts';
import Conclave from "../Assests/Activities/Conclave.jpg";
import HC_T_nagar from "../Assests/Activities/Health Camp-T. Nagar.jpg";
import HC_Alwarpet from "../Assests/Activities/Health Camp – Alwarpet.jpg";
import HC_ECR from "../Assests/Activities/Health Camp –ECR.jpg";
import HC_MylaporeClub from "../Assests/Activities/Health Camp – Mylapore Club.jpg";
import HC_University from "../Assests/Activities/Health Camp – University of Madras.png";
import Swarnaprashana from "../Assests/Activities/Swarnaprashana.jpg";
import Stakeholders from "../Assests/Activities/Stakeholders.jpg";
import  mouImage from "../Assests/Activities/MoU.jpg";



const activitiesData = [
    {
        date: "9–10 January 2026[cite: 1]",
        activity: "International Ayurveda Conclave – Manapakkam[cite: 1]",
        details: "Conducted a health camp and showcased our Ayurvedic products. Over 100 people benefited from the camp.[cite: 1]",
        image: Conclave
    },
    {
        date: "21 April 2026[cite: 1]",
        activity: "MoU with SCSVMV[cite: 1]",
        details: "Established an institutional collaboration with Sri Chandrasekharendra Saraswathi Viswa Mahavidyalaya (SCSVMV) for the supply of Ayurvedic medicines and research support.[cite: 1]",
        image: mouImage
    },
    {
        date: "2 May 2026[cite: 1]",
        activity: "Ayurveda Health Camp – Stenographers Guild, T. Nagar[cite: 1]",
        details: "Conducted a health camp, with over 100 people benefiting from free Ayurvedic consultation.[cite: 1]",
        image: HC_T_nagar
    },
    {
        date: "8–10 June 2026[cite: 1]",
        activity: "Ayurveda Health Camp – Asthika Samajam, Venus Colony, Alwarpet[cite: 1]",
        details: "Conducted a three-day health camp, with over 150 people benefiting from free Ayurvedic consultation.[cite: 1]",
        image: HC_Alwarpet
    },
    {
        date: "27–28 June 2026[cite: 1]",
        activity: "Founder's Day Mega Health Camp – Mylapore Club[cite: 1]",
        details: "Organised a mega health camp as part of the Founder's Day celebrations with over 150 people benefiting.[cite: 1]",
        image: HC_MylaporeClub
    },
    {
        date: "15 July 2026[cite: 1]",
        activity: "Swarnaprashana Programme Launch[cite: 1]",
        details: "Launched the Swarnaprashana Programme at the dispensary in the presence of the Honourable Minister for Food and Civil Supplies, Thiru. Venkataramanan.[cite: 1]",
        image: Swarnaprashana
    },
    {
        date: "24 July 2026[cite: 1]",
        activity: "Ayurveda Health Camp – Jagannath Temple, ECR[cite: 1]",
        details: "Conducted a health camp with over 50 people benefiting from free Ayurvedic consultation.[cite: 1]",
        image: HC_ECR
    },
    {
        date: "4 August 2026[cite: 1]",
        activity: "TN-RISE Stakeholders Meeting[cite: 1]",
        details: "Managing Trustee Shyam Swaminathan Raghunandan presented the institution's activities, achievements and vision for future collaborations to TN-RISE stakeholders meeting.[cite: 1]",
        image: Stakeholders
    },
    {
        date: "5 August 2026[cite: 1]",
        activity: "Founder's Day Mega Health Camp – University of Madras[cite: 1]",
        details: "Conducted a health camp at the University of Madras, with over 200 people benefiting from free Ayurvedic consultation.[cite: 1]",
        image: HC_University
    }
];

export default function ActivitiesPage() {
    return (
        <Layouts>
            <div className="bg-gray-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto">

                    <div className="text-center mb-12">
                        <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">
                            Institutional Activities
                        </h1>
                        <p className="mt-4 text-xl text-gray-500">
                            A timeline of our health camps, collaborations, and community events in 2026.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {activitiesData.map((item, index) => (
                            <div
                                key={index}
                                className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-lg transition-shadow duration-300 flex flex-col"
                            >
                                <div className="h-64 overflow-hidden">
                                    <img
                                        src={item.image}
                                        alt={item.activity.replace('[cite: 1]', '')}
                                        className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-500"
                                        loading="lazy"
                                    />
                                </div>

                                <div className="p-6 flex flex-col flex-grow">
                                    <div className="flex items-center text-sm font-semibold text-green-600 mb-2">
                                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                        </svg>
                                        {/* Removing the citation tag for cleaner UI rendering, but it remains in the data source */}
                                        {item.date.replace('[cite: 1]', '')}
                                    </div>

                                    <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                                        {item.activity.replace('[cite: 1]', '')}
                                    </h3>

                                    <p className="text-gray-600 text-sm flex-grow">
                                        {item.details.replace('[cite: 1]', '')}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </Layouts>
    );
}